import { useCallback, useEffect, useRef } from 'react';

/**
 * Batches rapid updates into requestAnimationFrame ticks (high-FPS drag/resize).
 */
export function useRafThrottle(onFrame) {
  const cbRef = useRef(onFrame);
  cbRef.current = onFrame;
  const rafRef = useRef(null);
  const pendingRef = useRef(null);

  const cancel = useCallback(() => {
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    }
    pendingRef.current = null;
  }, []);

  const schedule = useCallback((payload) => {
    pendingRef.current = payload;
    if (rafRef.current) return;
    rafRef.current = requestAnimationFrame(() => {
      rafRef.current = null;
      const data = pendingRef.current;
      pendingRef.current = null;
      if (data !== null && data !== undefined) {
        cbRef.current(data);
      }
    });
  }, []);

  useEffect(() => () => cancel(), [cancel]);

  return { schedule, cancel };
}
